export const RightArrowSvg = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    className="self-center"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        <g transform="translate(3, 7)">
          <line x1="0" y1="5" x2="18" y2="5" />
          <path d="M13,0 L18,5 L13,10" />
        </g>
      </g>
    </g>
  </svg>
);
